.icon {
  color: var(--color-specific-icon-bg);
}
